import React from "react";
import { useSignInWithGithub, useSignInWithGoogle } from "react-firebase-hooks/auth";
import { auth } from "../../../../firebase.init";
import github from "../../../../img/Social/github.svg";
import google from "../../../../img/Social/google.svg";

const SocialLogin = () => {
    const [signInWithGoogle, guser, gloading, gerror] = useSignInWithGoogle(auth);
    const [signInWithGithub, gituser, gitloading, giterror] = useSignInWithGithub(auth);


  return (
    <div className="mb-5">
      <div className="others-login d-flex gap-2 ">
        <button
         onClick={() => signInWithGoogle()}
         className="btn btn-google border"
         >
          {" "}
          <img src={google} style={{ width: "18px" }} alt="" /> Google
        </button>
        <button 
        onClick={() => signInWithGithub()}
        className="btn btn-github border">
          {" "}
          <img style={{ width: "20px" }} src={github} alt="" /> GitHub
        </button>
      </div>
    </div>
  );
};

export default SocialLogin;
